// A version belongs to a chart, not to a React render or an audit-hours request.
// Serialize reads and writes so the next save always uses the committed version.
export function createAuditSheetSession() {
  const versions = new Map();
  const requests = new Map();

  function enqueue(uploadId, operation) {
    const key = String(uploadId);
    const next = (requests.get(key) || Promise.resolve()).catch(() => {}).then(operation);
    requests.set(key, next);
    return next;
  }

  return {
    read(uploadId, load) {
      return enqueue(uploadId, async () => {
        const response = await load();
        versions.set(String(uploadId), response.version);
        return response;
      });
    },
    write(uploadId, save) {
      return enqueue(uploadId, async () => {
        const key = String(uploadId);
        const response = await save(versions.get(key) ?? 0);
        if (Number.isInteger(response?.version)) versions.set(key, response.version);
        return response;
      });
    },
  };
}
